import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatosGeneralesService } from './datos-generales.service';
import { ClienteIndividualEntity } from './entities/datos_generales_individual_entity';
import { UbicacionEntity } from './entities/ubicacion_entity';
import { EstadoCivilEntity } from './entities/estado_civil_entity'
import { ClienteLogin } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { CalendarFechaNacParametros } from "../../../components/common/utils/calendarFechaNacParametros";
import { UtilService } from "../../../components/common/utils/util.service";
import { SessionStorageService } from "ngx-webstorage";

const swal = require("sweetalert2");


declare var jQuery: any;

@Component({
    selector: 'infoClienteIndividual',
    providers: [DatosGeneralesService],
    templateUrl: 'datos-generales-individual.template.html',
    styleUrls: ["datos-generales.style.css"]
})
export class datosGeneralesIndividual extends CalendarFechaNacParametros implements OnInit {
    usuario: ClienteLogin;
    clienteMasivosIndividual: ClienteIndividualEntity;
    listaEstadosClivl: EstadoCivilEntity[];
    provincias: UbicacionEntity[];
    ciudades: UbicacionEntity[];
    sectores: UbicacionEntity[];
    ciudadesTrabajo: UbicacionEntity[];
    sectoresTrabajo: UbicacionEntity[];
    errorMessage: string;
    showLoader: string;
    inicioAnio: number;
    finAnio: number;
    idcorrespondencia: number;    

    constructor(
        public utilsService: UtilService,
        private datosGeneralesIndividualSevice: DatosGeneralesService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private sesionStorageService: SessionStorageService
    ) {
        super();
    }

    instanciaCiudadSectorDomicilio(): void {
        this.clienteMasivosIndividual.CodCiudadDomicilio = 0;
        this.clienteMasivosIndividual.CiudadDomicilio = "";
        this.clienteMasivosIndividual.CodSectorDomicilio = 0;
        this.clienteMasivosIndividual.SectorDomicilio = "";
    }

    instanciaCiudadSectorTrabajo(e: any): void {
        this.clienteMasivosIndividual.CodSectorTrabajo = 0;
        this.clienteMasivosIndividual.SectorTrabajo = "";
    }


    actualizarClienteIndividual(): void {
        this.datosGeneralesIndividualSevice.actualizarClienteIndividual(this.clienteMasivosIndividual).subscribe(
            datosClienteIndividual => {
                if (datosClienteIndividual) {
                    swal({
                        title: 'Datos actualizados',
                        text: "Su información ha sido actualizada satisfactoriamente",
                        type: 'success'
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); });
    }


    cargarCiudades(provCod): void {
        if (provCod != "0") {
            this.datosGeneralesIndividualSevice.consultaCiudades(provCod).subscribe(ciudades => {
                this.ciudades = ciudades;
                if (this.ciudades.length == 0) {
                    this.clienteMasivosIndividual.CodCiudadDomicilio = null;
                }
            }, error => this.handleError.redirectUrl(error))
        } else {
            this.ciudades = null;
            this.sectores = null;
            this.instanciaCiudadSectorDomicilio();
        }
    }

    cargarSectores(ciuCod): void {
        if (ciuCod != "0") {
            this.datosGeneralesIndividualSevice.consultaSectores(ciuCod).subscribe(sectores => {
                this.sectores = sectores;
                if (this.sectores.length == 0)
                    this.clienteMasivosIndividual.CodSectorDomicilio = 0;
            }, error => this.handleError.redirectUrl(error))
        } else {
            this.sectores = null;
            this.clienteMasivosIndividual.CodSectorDomicilio = 0;
            this.clienteMasivosIndividual.CodCiudadDomicilio = 0;
        }
    }
    cargarCiudadesTrabajo(provCod): void {
        if (provCod != "0") {
            this.datosGeneralesIndividualSevice.consultaCiudades(provCod).subscribe(ciudades => {
                this.ciudadesTrabajo = ciudades;
                if (this.ciudadesTrabajo.length == 0) {
                    this.clienteMasivosIndividual.CodCiudadTrabajo = null;
                }
            }, error => this.handleError.redirectUrl(error))
        } else {
            this.ciudadesTrabajo = null;
            this.sectoresTrabajo = null;
            this.clienteMasivosIndividual.CodCiudadTrabajo = 0;
            this.clienteMasivosIndividual.CodSectorTrabajo = 0;
        }
    }

    cargarSectoresTrabajo(ciuCod): void {
        if (ciuCod != "0") {
            this.datosGeneralesIndividualSevice.consultaSectores(ciuCod).subscribe(sectores => {
                this.sectoresTrabajo = sectores;
                if (this.sectoresTrabajo.length == 0)
                    this.clienteMasivosIndividual.CodSectorTrabajo = null;
            }, error => this.handleError.redirectUrl(error))
        } else {
            this.sectoresTrabajo = null;
            this.clienteMasivosIndividual.CodSectorTrabajo = 0;
        }
    }

    ngOnInit(): void {
        /*correctHeight();
        detectBody();*/
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.clienteMasivosIndividual = new ClienteIndividualEntity();                
                this.datosGeneralesIndividualSevice.consultaEstadoCivil().subscribe(listaEstadosClivl => this.listaEstadosClivl = listaEstadosClivl, error => this.handleError.redirectUrl(error))
                this.datosGeneralesIndividualSevice.consultaProvincias().subscribe(provincias => this.provincias = provincias, error => this.handleError.redirectUrl(error))
                this.datosGeneralesIndividualSevice.datosClienteIndividual().subscribe(
                    datosClienteIndividual => {
                        this.clienteMasivosIndividual = datosClienteIndividual;
                        if(this.clienteMasivosIndividual.CodProvinciaDomicilio == null){
                            this.clienteMasivosIndividual.CodProvinciaDomicilio = 0;
                        }
                        if(this.clienteMasivosIndividual.CodProvinciaTrabajo == null){
                            this.clienteMasivosIndividual.CodProvinciaTrabajo = 0;
                        }
                        if(this.clienteMasivosIndividual.CodCiudadDomicilio == null){
                            this.clienteMasivosIndividual.CodCiudadDomicilio = 0;
                        }
                        if(this.clienteMasivosIndividual.CodCiudadTrabajo == null){
                            this.clienteMasivosIndividual.CodCiudadTrabajo = 0;
                        }
                        if(this.clienteMasivosIndividual.CodSectorDomicilio == null){
                            this.clienteMasivosIndividual.CodSectorDomicilio = 0;
                        }
                        if(this.clienteMasivosIndividual.CodSectorTrabajo == null){
                            this.clienteMasivosIndividual.CodSectorTrabajo = 0;
                        }
                        this.cargarCiudades(datosClienteIndividual.CodProvinciaDomicilio);
                        this.cargarSectores(datosClienteIndividual.CodCiudadDomicilio);
                        this.cargarCiudadesTrabajo(datosClienteIndividual.CodProvinciaTrabajo);
                        this.cargarSectoresTrabajo(datosClienteIndividual.CodCiudadTrabajo);
                        this.sesionStorageService.store("NombreUser", JSON.stringify(this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno));
                    },
                    error => { this.handleError.redirectUrl(error); });
            }
        }
    }

    set dateS(e) {
        this.clienteMasivosIndividual.FechaNacimiento = new Date(e);
    }

    get dateS() {
        if (this.clienteMasivosIndividual.FechaNacimiento != undefined) {
            try {
                var a = this.clienteMasivosIndividual.FechaNacimiento.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.clienteMasivosIndividual.FechaNacimiento.toString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/datos-generales-individual.component.ts